import { USER_SEGMENT_ENUM } from 'integration/resources/auth'

import { MultiplierValuesType, Tab } from '../RVCalculators2026.types'

export const rolesGR = [
  'GTE RELAC FINANC I',
  'GTE RELAC FINANC II',
  'GTE RELAC FINANC III (FIN)',
  'ESPEC COML FINANCEIRA I',
  'ESPEC COML FINANCEIRA II',
  'ESPEC COML FINANCEIRA III'
]

type TargetItem = { id: string; name: string; value: number }

const specialistTargetsLojas: TargetItem[] = [
  { id: 'spec-lojas-i', name: 'Especialista I', value: 1050 },
  { id: 'spec-lojas-ii', name: 'Especialista II', value: 1450 }
]

const specialistTargetsCss: TargetItem[] = [
  { id: 'spec-css-i', name: 'Especialista I', value: 1272 },
  { id: 'spec-css-ii-iii', name: 'Especialista II e III', value: 1526 }
]

const specialistTargetsBs: TargetItem[] = [
  { id: 'spec-bs-i', name: 'Especialista I', value: 1272 },
  { id: 'spec-bs-ii-iii', name: 'Especialista II e III', value: 1526 }
]

const specialistTargetsAdmin: TargetItem[] = [
  { id: 'spec-lojas-i', name: 'Especialista I (Lojas)', value: 1050 },
  { id: 'spec-lojas-ii', name: 'Especialista II (Lojas)', value: 1450 },
  { id: 'spec-css-i', name: 'Especialista I (CSS)', value: 1272 },
  { id: 'spec-css-ii-iii', name: 'Especialista II e III (CSS)', value: 1526 },
  { id: 'spec-bs-i', name: 'Especialista I (B&S)', value: 1272 },
  { id: 'spec-bs-ii-iii', name: 'Especialista II e III (B&S)', value: 1526 }
]

const porteTargets: TargetItem[] = [
  { id: 'porte-c', name: 'Porte C', value: 3170 },
  { id: 'porte-b', name: 'Porte B', value: 3590 },
  { id: 'porte-a', name: 'Porte A', value: 4170 },
  { id: 'porte-aa', name: 'Porte AA', value: 5004 }
]

const resultTargetsLojas: TargetItem[] = [
  { id: 'spec-lojas-i', name: 'Especialista I', value: 2100 },
  { id: 'spec-lojas-ii', name: 'Especialista II', value: 2900 }
]

const resultTargetsCss: TargetItem[] = [
  { id: 'spec-css-i', name: 'Especialista I', value: 2544 },
  { id: 'spec-css-ii-iii', name: 'Especialista II e III', value: 3052 }
]

const resultTargetsBs: TargetItem[] = [
  { id: 'spec-bs-i', name: 'Especialista I', value: 2544 },
  { id: 'spec-bs-ii-iii', name: 'Especialista II e III', value: 3052 }
]

const resultTargetsAdmin: TargetItem[] = [
  { id: 'spec-lojas-i', name: 'Especialista I (Lojas)', value: 2100 },
  { id: 'spec-lojas-ii', name: 'Especialista II (Lojas)', value: 2900 },
  { id: 'spec-css-i', name: 'Especialista I (CSS)', value: 2544 },
  { id: 'spec-css-ii-iii', name: 'Especialista II e III (CSS)', value: 3052 },
  { id: 'spec-bs-i', name: 'Especialista I (B&S)', value: 2544 },
  { id: 'spec-bs-ii-iii', name: 'Especialista II e III (B&S)', value: 3052 }
]

const getSpecialistsBySegment = (segment?: USER_SEGMENT_ENUM) => {
  switch (segment) {
    case USER_SEGMENT_ENUM.CSS:
      return specialistTargetsCss

    case USER_SEGMENT_ENUM.B_S:
      return specialistTargetsBs

    case USER_SEGMENT_ENUM.LEVES:
      return specialistTargetsLojas

    case USER_SEGMENT_ENUM.LOJAS:
      return specialistTargetsLojas

    default:
      return specialistTargetsLojas
  }
}

const getResultSpecialistsBySegment = (segment?: USER_SEGMENT_ENUM) => {
  switch (segment) {
    case USER_SEGMENT_ENUM.CSS:
      return resultTargetsCss

    case USER_SEGMENT_ENUM.B_S:
      return resultTargetsBs

    case USER_SEGMENT_ENUM.LEVES:
      return resultTargetsLojas

    case USER_SEGMENT_ENUM.LOJAS:
      return resultTargetsLojas

    default:
      return resultTargetsLojas
  }
}

export const targets = [...specialistTargetsAdmin, ...porteTargets]

export const resultsTargets = resultTargetsAdmin

export const getTargetsBySegment = (segment?: USER_SEGMENT_ENUM, isAdmin?: boolean) => {
  if (isAdmin) return [...specialistTargetsAdmin, ...porteTargets]

  return [...getSpecialistsBySegment(segment), ...porteTargets]
}

export const getResultsTargetsBySegment = (segment?: USER_SEGMENT_ENUM, isAdmin?: boolean) => {
  if (isAdmin) return resultTargetsAdmin

  return getResultSpecialistsBySegment(segment)
}

export const performanceValues = [0, 5, 15, 30]

export const expensesValues = [-5, -3, -2, 0]

export const chargeGoalValues = [1, 2]

export const multiplierValues: MultiplierValuesType = {
  2: { withInsurance: 1, withoutInsurance: 1 },
  3: { withInsurance: 1.4, withoutInsurance: 1.2 },
  4: { withInsurance: 1.8, withoutInsurance: 1.4 },
  5: { withInsurance: 2.3, withoutInsurance: 1.8 },
  6: { withInsurance: 4.0, withoutInsurance: 4.0 }
}

export const resultMultiplierValues: MultiplierValuesType = {
  0: { withInsurance: 1, withoutInsurance: 1 },
  1: { withInsurance: 1.2, withoutInsurance: 1.1 },
  2: { withInsurance: 1.4, withoutInsurance: 1.2 },
  3: { withInsurance: 2, withoutInsurance: 1.5 },
  4: { withInsurance: 2.8, withoutInsurance: 2 },
  5: { withInsurance: 4, withoutInsurance: 3 }
}

export const indicatorsLines = [
  'Produção',
  'Prestamista',
  'SA',
  'Cobrança',
  'Webmotors',
  'Ecossistema',
  '↳ Base Ativa',
  '↳ +Contas',
  'Total'
]

export const tabsConfig: Tab[] = [
  {
    id: 1,
    title: `Calculadora Bloco de Negócios`,
    subtitle: 'Simule seus ganhos de remuneração variável e compare com sua RV atual',
    observations: [
      `Este “SIMULADOR” deve ser utilizado para simples estimativas e para esclarecer eventuais pontos sobre o cálculo do programa de RV 2026. Ele não considera eventuais proporcionalidades nem representa critérios oficiais de elegibilidade, apuração e pagamento.`
    ]
  },
  {
    id: 3,
    title: 'Calculadora de Resultados',
    subtitle: 'Subtítulo contextualizando a calculadora.',
    observations: [
      `Este “SIMULADOR” deve ser utilizado para simples estimativas e para esclarecer eventuais pontos sobre o cálculo do programa de RV 2026. Ele não considera eventuais proporcionalidades nem representa critérios oficiais de elegibilidade, apuração e pagamento.`
    ]
  }
]
